module.exports = __webpack_public_path__ + "img/ZFBbarcode2.a04370f4.png";